var exports = {
  "d": "x52a3aa3b--f13cc7--gpt-button",
};

module.exports = exports;
